import React from 'react';
import ColataShell from '../../components/colata/ColataShell';
import TabellaArticoli from './components/TabellaArticoli';

// /colata-magazzino — articoli, giacenze, carico e rettifica
const ColataMagazzinoPage = () => (
  <ColataShell indietroA="/colata-inventory">
    <TabellaArticoli />
  </ColataShell>
);

export default ColataMagazzinoPage;
